import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  debounce,
  isEmpty,
  get,
  find,
} from 'lodash';
import SelectField from '../SelectField';

const DISTANCE_OPTIONS = [
  { label: '1 Mile', value: '1mi' },
  { label: '5 Miles', value: '5mi' },
  { label: '10 Miles', value: '10mi' },
  { label: '25 Miles', value: '25mi' },
  { label: '50 Miles', value: '50mi' },
  { label: '100 Miles', value: '100mi' },
  { label: 'Any Distance', value: 'any' },
];

export const MAP_CENTER = 'map-center';

const FROM_OPTIONS = [
  { value: MAP_CENTER, display_name: 'Map Center' },
  { value: 'other-address', display_name: 'Other Address' },
];

class DistanceFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      address: props.values.address,
      geocodeResults: [],
    };

    this.onAddressChange = this.onAddressChange.bind(this);
    this.onResultClick = this.onResultClick.bind(this);
    this.searchAddress = this.searchAddress.bind(this);
    this.debouncedSearchAddress = debounce(this.searchAddress, 300);
  }

  onAddressChange(event, performGeocoding = true) {
    const { onFieldChange } = this.props;
    const address = onFieldChange(event);
    this.setState({
      address,
    }, () => performGeocoding && this.debouncedSearchAddress());
  }

  onResultClick(event) {
    const placeId = get(event, 'target.id', '');
    const { geocodeResults } = this.state;
    const { map } = this.props;
    const selectedAddress = find(geocodeResults, { place_id: placeId });

    if (selectedAddress && map) {
      map.setCenter(selectedAddress.geometry.location);
      this.onAddressChange({
        target: {
          name: 'address',
          value: selectedAddress.formatted_address,
        },
      }, false);
      this.setState({ geocodeResults: [] });
    }
  }

  searchAddress() {
    const { google } = this.props;
    const { address } = this.state;
    if (isEmpty(google) || isEmpty(address)) {
      return;
    }

    const geoCoder = new google.maps.Geocoder();
    geoCoder.geocode({ address }, (results, status) => {
      if (status === 'OK') {
        this.setState({
          geocodeResults: results,
        });
      } else {
        console.warn(`Geocode was not successful for the following reason: ${status}`); // eslint-disable-line
      }
    });
  }

  render() {
    const {
      values,
      onFieldChange,
    } = this.props;

    const {
      address,
      geocodeResults,
    } = this.state;

    return (
      <div className="uu-distance-filter">
        <div className="uu-distance-filter__distance">
          <label htmlFor="uu-distance">
            Distance
          </label>
          <SelectField
            id="uu-distance"
            name="distance"
            onChange={onFieldChange}
            value={values.distance}
            options={DISTANCE_OPTIONS}
            labelKey="label"
            valueKey="value"
            removeButton={false}
          />
        </div>
        <div className="uu-distance-filter__distance-from">
          <label htmlFor="uu-distance-from">
            From
          </label>
          <SelectField
            id="uu-distance-from"
            name="distance_from"
            onChange={onFieldChange}
            value={values.distance_from}
            options={FROM_OPTIONS}
            removeButton={false}
          />
        </div>
        {
          values.distance_from !== MAP_CENTER && (
            <div className="uu-distance-filter__address">
              <label htmlFor="uu-distance-address">
                Address
              </label>
              <input
                autoComplete="off"
                id="uu-distance-address"
                name="address"
                onChange={this.onAddressChange}
                value={address}
              />
              <ul className="uu-distance-filter__geocode-results">
                {
                  geocodeResults.map(result => (
                    <li
                      className="uu-distance-filter__geocode-results-item"
                      key={result.place_id}
                    >
                      <button
                        id={result.place_id}
                        onClick={this.onResultClick}
                        type="button"
                      >
                        {result.formatted_address}
                      </button>
                    </li>
                  ))
                }
              </ul>
            </div>
          )
        }
      </div>
    );
  }
}

DistanceFilter.propTypes = {
  google: PropTypes.object,
  map: PropTypes.object,
  onFieldChange: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
};

DistanceFilter.defaultProps = {
  google: {},
  map: {},
};

export default DistanceFilter;



// WEBPACK FOOTER //
// ./public/js/components/Search/DistanceFilter.jsx